// src/features/TunnelAnalysis/hooks/useTunnelData.js
import { useState, useEffect, useMemo } from 'react';
import { getData } from '../../../services/storageService';

// Створюємо правильний TUNNEL_CONFIG як об'єкт
export const TUNNEL_CONFIG = {
  'tunnel_program1': { programName: 'Programa 1', unit: 'kg', type: 'production', color: 'primary' },
  'tunnel_program2': { programName: 'Programa 2', unit: 'kg', type: 'production', color: 'primary' },
  'tunnel_rejection1': { programName: 'Rechazo 1', unit: 'kg', type: 'rejection', color: 'error' },
  // Додайте інші програми тунелю тут
};

export const useTunnelData = (selectedProgram = null) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const allRecords = await getData('lainsa_records');
        setRecords(Array.isArray(allRecords) ? allRecords : []);
      } catch (err) {
        console.error('Error loading tunnel data:', err);
        setError('Failed to load tunnel data');
        setRecords([]);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Обробляємо дані для всіх програм
  const allProgramsData = useMemo(() => {
    const result = {};
    
    Object.keys(TUNNEL_CONFIG).forEach(programKey => {
      const programRecords = records
        .filter(record => {
          const field = TUNNEL_CONFIG[programKey].type === 'production' ? 'tunel' : 'rech_tunel';
          return record.recordType === 'shift_report' && 
                 record[field] && 
                 record[field][programKey] !== undefined &&
                 record[field][programKey] !== null &&
                 record[field][programKey] !== '';
        })
        .map(record => {
          const field = TUNNEL_CONFIG[programKey].type === 'production' ? 'tunel' : 'rech_tunel';
          return {
            date: record.fecha,
            value: Number(record[field][programKey]) || 0,
            shift: record.turno,
            operators: record.operators
          };
        })
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      // Розраховуємо статистику
      const values = programRecords.map(r => r.value).filter(v => v > 0);
      const statistics = values.length > 0 ? {
        total: values.reduce((a, b) => a + b, 0),
        average: values.reduce((a, b) => a + b, 0) / values.length,
        max: Math.max(...values),
        min: Math.min(...values),
        daysWithData: values.length,
        recordsCount: programRecords.length
      } : {
        total: 0, average: 0, max: 0, min: 0, daysWithData: 0, recordsCount: 0
      };

      result[programKey] = {
        data: programRecords,
        statistics,
        config: TUNNEL_CONFIG[programKey]
      };
    });

    return result;
  }, [records]);

  // Дані для обраної програми
  const selectedProgramData = selectedProgram ? allProgramsData[selectedProgram] : null;

  return {
    allProgramsData,
    selectedProgramData,
    loading,
    error,
    tunnelConfig: TUNNEL_CONFIG
  };
};


